import { render } from "./AssignUserInfrastructure.vue?vue&type=template&id=5174ff12&scoped=true"
import script from "./AssignUserInfrastructure.vue?vue&type=script&lang=js"
export * from "./AssignUserInfrastructure.vue?vue&type=script&lang=js"

import "./AssignUserInfrastructure.vue?vue&type=style&index=0&id=5174ff12&scoped=true&lang=css"

import exportComponent from "/tmp/build_ada65e43/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5174ff12"]])

export default __exports__